<template>
    <div class="buttons-dropdown">
        <b-button-group>
            <b-button
                    v-for="(option, index) in options"
                    :key="index"
                    size="lg"
                    :variant="option.value === internalModel.value ? 'primary' : 'secondary'"
                    @click="handleInput(option)"
            >
                {{ option.label }}
            </b-button>
        </b-button-group>
    </div>
</template>
<script>
    import './ButtonsDropdown.scss';

    export default {
        name: 'ButtonsDropdown',
        props: {
            value: {
                type: Object,

            },
            options: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                internalModel: this.value
            };
        },
        methods: {
            handleInput(value) {
                this.internalModel = value;
                this.$emit('input', this.internalModel);
            }
        }
    };
</script>
